/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import AdditionalNotes from '@/components/new-order/AdditionalNotes';
import Addons from '@/components/new-order/Addons';
import ContactInformation from '@/components/new-order/ContactInformation';
import CustomStepper from '@/components/new-order/CustomStepper';
import InspectionType from '@/components/new-order/InspectionType';
import Summary from '@/components/new-order/Summary';
import VehicleInformation from '@/components/new-order/VehicleInformation';
import { useNewOrder } from '@/context/NewOrderContext';
import { Button } from "__barrel_optimize__?names=Button!=!@mui/material";
import React from 'react';
import toast from 'react-hot-toast';
import ReferralCodeDialog from './ReferralCodeDialog';
function UnprotectedOrder() {
    const { step, setStep, order, setOrder, referralCode } = useNewOrder();
    const handleNext = async ()=>{
        switch(step){
            case 1:
                if (!order.stripe_product) {
                    toast.error('Please select an inspection type to continue.');
                    return;
                } else {
                    setStep(step + 1);
                }
                break;
            case 2:
                if (!order.vehicle.make || !order.vehicle.model || !order.vehicle.year || !order.vehicle_contact_name || !order.vehicle_contact_email || !order.vehicle_contact_phone) {
                    toast.error('Please fill out all required vehicle information fields to continue.');
                    return;
                } else {
                    setStep(step + 1);
                }
                break;
            case 3:
                if (!order.customer.first_name || !order.customer.last_name || !order.customer.email || !order.customer.phone) {
                    toast.error('Please fill out all required contact information fields to continue.');
                    return;
                } else {
                    setStep(step + 1);
                }
                break;
            case 4:
                setStep(step + 1);
                break;
            case 5:
                if (!order.id) {
                    const response = await fetch('/api/order', {
                        method: "POST",
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            order: {
                                ...order,
                                referral_code: referralCode || null
                            }
                        })
                    });
                    if (!response.ok) {
                        const errorData = await response.json();
                        toast.error(errorData.error || 'Failed to create order. Please try again.');
                        return;
                    }
                    const responseData = await response.json();
                    setOrder({
                        ...order,
                        id: responseData.order_id
                    });
                }
                setStep(step + 1);
                break;
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex flex-col h-5/6",
        children: [
            /*#__PURE__*/ _jsx(CustomStepper, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex-1",
                children: [
                    step === 1 && /*#__PURE__*/ _jsx(InspectionType, {}),
                    step === 2 && /*#__PURE__*/ _jsx(VehicleInformation, {}),
                    step === 3 && /*#__PURE__*/ _jsx(ContactInformation, {}),
                    step === 4 && /*#__PURE__*/ _jsx(Addons, {}),
                    step === 5 && /*#__PURE__*/ _jsx(AdditionalNotes, {}),
                    step === 6 && /*#__PURE__*/ _jsx(Summary, {})
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-row items-center justify-between mt-10",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(Button, {
                            disabled: step === 1,
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            onClick: ()=>{
                                setStep(step - 1);
                            },
                            children: "Previous"
                        })
                    }),
                    /*#__PURE__*/ _jsx(ReferralCodeDialog, {}),
                    /*#__PURE__*/ _jsx("div", {
                        children: step !== 6 && /*#__PURE__*/ _jsx(Button, {
                            disabled: step === 6,
                            variant: "contained",
                            color: "primary",
                            size: "large",
                            onClick: handleNext,
                            children: "Continue"
                        })
                    })
                ]
            })
        ]
    });
}
export default UnprotectedOrder;
